import { render, staticRenderFns } from "./QTag.vue?vue&type=template&id=1e16929b&scoped=true"
import script from "./QTag.vue?vue&type=script&lang=js"
export * from "./QTag.vue?vue&type=script&lang=js"
import style0 from "./QTag.vue?vue&type=style&index=0&id=1e16929b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e16929b",
  null
  
)

/* custom blocks */
import block0 from "./QTag.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports